import { hideToast } from 'actions/toast';

export default dispatch => ({
  hideToast: () => dispatch(hideToast()),
});
